export function reunionToday(now = new Date()) {
  return new Date(now.getTime() + 4 * 60 * 60 * 1000).toISOString().slice(0, 10);
}

export function canRequest(form, vehicle, availability, today) {
  return Boolean(vehicle && form.date_mariage >= today &&
    availability?.date === form.date_mariage && availability.available === true &&
    form.client_name.trim() && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.client_email.trim()) &&
    /^[+\d\s().-]+$/.test(form.client_telephone.trim()) &&
    form.client_telephone.replace(/\D/g, '').length >= 10 && form.consentement);
}

export function requestPayload(form) {
  // Preserve unknown details as unknown: never invent addresses, times or preferences.
  return Object.fromEntries(Object.entries(form).map(([key, value]) =>
    [key, typeof value === 'string' ? value.trim() : value]));
}
